import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DistribucionAnexo21y22RMF2026ProgramaInformatico() {
  return (
    <CategoryPage
      category="distribucionAnexo21Y22Rmf2026ProgramaInformatico2026"
      pageTitle="Programa Informatico 2026"
    />
  );
}

export default DistribucionAnexo21y22RMF2026ProgramaInformatico;
